import { ReactNode, useState, CSSProperties } from "react";
import { C } from "./designTokens";

interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: "primary" | "secondary" | "coral" | "outline" | "ghost";
  size?: "sm" | "default" | "lg";
  className?: string;
  style?: CSSProperties;
  type?: "button" | "submit" | "reset";
}

export default function Button({
  children,
  onClick,
  variant = "primary",
  size = "default",
  className = "",
  style: customStyle = {},
  type = "button",
}: ButtonProps) {
  const [hovered, setHovered] = useState(false);

  const variants: Record<string, CSSProperties> = {
    primary: {
      background: C.navy,
      color: C.white,
      border: "none",
    },
    secondary: {
      background: "transparent",
      color: C.navy,
      border: `1px solid ${C.gray200}`,
    },
    coral: {
      background: C.coral,
      color: C.white,
      border: "none",
    },
    outline: {
      background: "transparent",
      color: C.white,
      border: `1px solid ${C.gray300}`,
    },
    ghost: {
      background: "transparent",
      color: C.navy,
      border: "none",
    },
  };

  const sizes: Record<string, CSSProperties> = {
    sm: { padding: "10px 20px", fontSize: "13px" },
    default: { padding: "14px 28px", fontSize: "14px" },
    lg: { padding: "16px 32px", fontSize: "15px" },
  };

  const variantStyle = variants[variant];
  const sizeStyle = sizes[size];

  return (
    <button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={className}
      style={{
        fontFamily: C.font,
        fontWeight: 500,
        letterSpacing: "0.02em",
        cursor: "pointer",
        borderRadius: "6px",
        transition: "all 0.2s ease",
        background: hovered
          ? variant === "primary"
            ? C.navyLight
            : variantStyle.background
          : variantStyle.background,
        color: variantStyle.color,
        border: variantStyle.border,
        ...sizeStyle,
        ...customStyle,
      }}
    >
      {children}
    </button>
  );
}
